// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6362":"fe81e24a","7175":"7e697d47"}[chunkId] + ".chunk.css";
};